import { definitions } from 'api/generated/photo'

export const findCurrentIndex = (
  photos: definitions['OmniAlbumPhoto'][],
  photoId: string | number | undefined
): number => {
  if (photoId) {
    const index = photos.findIndex((item) => {
      return item.photoId === Number(photoId)
    })

    // А вдруг такой фотки нету: поэтому по умолчанию выставим 0 index
    return index > -1 ? index : 0
  }

  return 0
}
